export const selectAuth = (state) => state.auth;
export const selectAuthUser = (state) => state.auth.user;
export const selectAuthLoading = (state) => state.auth.isLoading;
export const selectAuthSuccess = (state) => state.auth.isSuccess;
export const selectAuthError = (state) => state.auth.isError;
export const selectAuthErrorMessage = (state) => state.auth.errorMessage;
export const selectIsAuthenticated = (state) => !!state.auth.user;